export const dbTabs2 = {
  ageRules: {
    heading: "Reglas de huéspedes",
    headHint:
      "Define quién es bebé, niño o adulto y cómo cuentan hacia la capacidad {scope}. Por defecto, los bebés no ocupan plaza ni se cobran.",
    scopeHotel: "de cada habitación",
    scopeApartment: "del alojamiento",
    loading: "Cargando reglas…",
    emptyHotel: "Este hotel no tiene habitaciones configuradas.",
    capacityChipTitle: "Capacidad de la habitación (se define en Capacidad)",
    slots: "{count} plaza | {count} plazas",
    badgeCustom: "Personalizadas",
    badgeStandard: "Estándar",
    applyAgeRules: "Aplicar reglas de edad",
    masterSubHotel: "Bebés, niños y capacidad personalizados en esta habitación.",
    masterSubApartment: "Bebés, niños y capacidad personalizados en este alojamiento.",
    standardNote:
      "Comportamiento estándar: los bebés no cuentan hacia la capacidad ni se cobran.",
    capacityLabel: "Capacidad",
    capacityGuestsNote:
      'huésped · se define en "Capacidad"; estas reglas solo ajustan quién cuenta | huéspedes · se define en "Capacidad"; estas reglas solo ajustan quién cuenta',
    infantUpTo: "Los bebés son hasta",
    years: "años",
    childToAdult: "Un niño pasa a adulto a los",
    maxInfants: "Máximo de bebés",
    perBooking: "por reserva",
    infantsOccupy: "Los bebés ocupan plaza",
    infantsCharged: "Los bebés se cobran",
    childrenCount: "Los niños cuentan como huésped",
    ageLegend:
      "Bebé: menos de {infant} años · Niño: {infant}–{childTo} años · Adulto: {adult}+ años.",
    listingCapacity: "Capacidad del anuncio",
    listingCapacityHint: 'Se define en "Capacidad" y se comparte con "Ocupación".',
    thisAccommodation: "Este alojamiento",
    loadError: "No se pudo cargar las reglas de huéspedes.",
    saveSuccess: "Reglas de huéspedes guardadas correctamente.",
    saveError: "No se pudo guardar las reglas de huéspedes.",
  },
  globalPayments: {
    title: "Pagos globales (Apartamentos/Villas)",
    pill: "Global",
    desc: "Esta configuración aplica a todas las propiedades tipo apartamento/villa del usuario.",
    loading: "Cargando configuración…",
    paymentType: "Tipo de pago",
    onArrivalLabel: "Pago a la llegada",
    onArrivalDesc: "El huésped reserva y paga directamente al llegar.",
    onlineLabel: "Pago online",
    onlineDesc: "El huésped paga online al completar la reserva.",
    savedAtUserLevel: "Se guarda a nivel de usuario para apartamentos/villas.",
    globalDiscount: "Descuento global",
    enableGlobalDiscount: "Activar descuento global",
    discountType: "Tipo de descuento",
    percentageLabel: "Porcentaje",
    percentageDesc: "Descuento proporcional al total.",
    fixedLabel: "Fijo",
    fixedDesc: "Cantidad fija a descontar.",
    valueTitle: "Valor",
    phPercentage: "Ej: 10",
    phFixed: "Ej: 15.00",
    helpPercentage: "Máximo 100%. Se aplica sobre el total.",
    helpFixed: "Se descuenta una cantidad fija en {currency}.",
    previewTitle: "Vista previa",
    previewPercentage: "Se aplicará un {percent}% de descuento global.",
    previewFixed: "Se aplicará un descuento global de {amount}.",
    appliesAllDirect: "Aplica para todas las reservas directas de apartamentos/villas.",
    saveSuccess: "Pagos globales guardados.",
    saveError: "No se pudieron guardar los pagos globales.",
  },
  payments: {
    loading: "Cargando configuración…",
    q02Title: "¿Cuándo paga el huésped?",
    savingBadge: "Guardando…",
    payOnArrivalName: "Pago a la llegada",
    payOnArrivalHint: "El huésped reserva y paga directamente al llegar.",
    payOnlineName: "Pago online",
    payOnlineHint: "El huésped paga online al completar la reserva.",
    q03Title: "Tiempo para pagar",
    onlineOnlyBadge: "Solo pago online",
    holdDesc:
      "El calendario se bloquea mientras el huésped completa el pago.<br>Si no paga en el tiempo indicado, <strong>la disponibilidad se libera automáticamente</strong>.",
    unitMin: "min",
    unitHour: "hora",
    unitHours: "horas",
    q04Title: "Cobro parcial",
    partialTitle: "Permitir pagar solo una parte al reservar",
    partialOnDesc:
      "<strong>Activado.</strong> El huésped podrá pagar el <strong>{percent}%</strong> ahora y el resto antes de llegar (o pagar el total).",
    partialOffDesc:
      "<strong>Desactivado.</strong> El huésped paga el <strong>total</strong> al reservar.",
    blockTitle: "El resto se paga en el alojamiento",
    blockOnDesc:
      "<strong>Activado.</strong> El huésped paga <strong>solo el {percent}%</strong> online; el resto lo abona <strong>al llegar</strong> (no podrá pagar el total por internet).",
    blockOffDesc:
      "<strong>Desactivado.</strong> El huésped puede elegir pagar el {percent}% o el total online.",
    q05Title: "Recordatorio de saldo",
    reminderTitle: "Enviar recordatorio de pago del saldo pendiente",
    reminderOnDesc:
      "<strong>Activado.</strong> <strong>{when}</strong> de la llegada (sobre las 09:00, hora de la propiedad) se envía al huésped un enlace para pagar el saldo pendiente por <strong>WhatsApp y correo</strong>.",
    reminderOffDesc:
      "<strong>Desactivado.</strong> El huésped no recibe recordatorio para pagar el saldo online antes de llegar.",
    daysBefore: "{count} día antes | {count} días antes",
    reminderDaysLabel: "Días antes de la llegada",
    reminderHint:
      "Se envía una sola vez, y solo a huéspedes con saldo pendiente. Si el resto se paga en el alojamiento, no se envía.",
    approveTitle: "Aprobar reservas",
    approveCardTitle: "Aprobar cada reserva antes de confirmarla",
    approveOnDesc:
      "<strong>Activado.</strong> Cada reserva queda <strong>pendiente de tu aprobación</strong>: recibes un aviso y decides si la aceptas o la rechazas. No se confirma hasta que tú la apruebas.",
    approveOffDesc:
      "<strong>Desactivado.</strong> Las reservas se <strong>confirman solas</strong> al completar el pago. Actívalo si prefieres revisar y aprobar tú mismo cada solicitud.",
    saveSuccess: "Guardado.",
    saveError: "No se pudieron guardar los cambios.",
  },
  unitConfig: {
    descByRoom: "Descripción por habitación",
    descByRoomHint:
      "Cada habitación tiene su propia descripción y su visibilidad en la reserva directa.",
    loadingRooms: "Cargando habitaciones…",
    emptyHotel: "Este hotel no tiene habitaciones configuradas.",
    visible: "Visible",
    hidden: "Oculta",
    roomDescPlaceholder: "Describe {name} (camas, comodidades, vistas…)",
    savingDesc: "Guardando…",
    autosaveHint: "Se guarda automáticamente al salir del campo.",
    loadingProperty: "Cargando datos del alojamiento…",
    loadErrorProperty: "No se pudo cargar la configuración de este alojamiento.",
    amenitiesByRoom: "Comodidades por habitación",
    amenitiesByRoomHint:
      "Cada habitación puede ofrecer comodidades distintas. La reserva directa y el Agente IA usan las de la habitación asignada al huésped.",
    amenitiesCount: "{count} comodidad | {count} comodidades",
    noAmenities: "Sin comodidades",
    titleDescription: "Descripción del alojamiento",
    titleServices: "Equipamiento y comodidades",
    subtitleDescription:
      "Edita la descripción que verán los huéspedes en tu página de reserva directa.",
    subtitleServices: "Marca lo que ofrece este alojamiento y sube sus fotos.",
  },
};
